import sustainabilityDataStore from '@/store/modules/SustainabilityData'
import SustainabilityConstants from '@/components/sustainability/SustainabilityConstants'
import NonConcurrentUploadService from '@/utils/NonConcurrentUploadService'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/systemModule/attachments`

export default {
  download(file) {
    return ApiService.get(`${ApiService.prefix}${file.downloadLink}`, {
      responseType: 'blob',
    }).then((response) => new File([response.data], file.label))
  },
  async upload(file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', file.name)
    formData.append('relationshipId', SustainabilityConstants.ATTACHMENT_RELATION_ID)
    formData.append('parentRecordId', sustainabilityDataStore.state.currentResultId)
    return NonConcurrentUploadService.post(`${resourceUrl}/upload`, formData).then((response) => {
      response.data.success = true
      response.data.label = response.data.fileName
      return response.data
    })
  },
  getFileList(parentRecordId) {
    return ApiService.get(`${resourceUrl}/fileList`, {
      params: {
        parentRecordId,
        relationshipId: SustainabilityConstants.ATTACHMENT_RELATION_ID,
      },
    })
  },
}
